<template>
	<pre v-html="$t('terms.agreement1')"></pre>
</template>

<script>
export default {
	name: 'Agreement1',
};
</script>

<style scoped></style>
